import { t } from "i18next";
import { lazy } from "react";
import { getRoute } from "util/react";

export const DriverReviewsRoute = getRoute(
  { fullPath: "/:locale?/driver/reviews/:carrierId" },
  "driver/reviews/:carrierId",
  lazy(() => import("./reviews")),
  null,
);

export const DriverCreateReviewRoute = getRoute(
  { fullPath: "/:locale?/driver/create-review/:id/:to" },
  "driver/create-review/:id/:to",
  lazy(() => import("./createReview")),
  null,
);

export const DriverNewOrdersRoute = getRoute(
  { fullPath: "/:locale?/driver/new-orders" },
  "driver/new-orders",
  lazy(() => import("./newOrders")),
  null,
);

export const DriverMyOrdersRoute = getRoute(
  { fullPath: "/:locale?/driver/my-orders" },
  "driver/my-orders",
  lazy(() => import("./myOrders")),
  null,
);

export const DriverArchiveRoute = getRoute(
  { fullPath: "/:locale?/driver/archive" },
  "driver/archive",
  lazy(() => import("./archive")),
  null,
);

export const DriverOrderDetailsRoute = getRoute(
  { fullPath: "/:locale?/driver/orders/:id" },
  "driver/orders/:id",
  lazy(() => import("./orderDetails")),
  null,
);

export const DriverProfileRoute = getRoute(
  { title: t("days_hours"), fullPath: "/:locale?/driver/profile/working-days" },
  "working-days",
  lazy(() => import("./profile/working-hours")),
  null,
);

export const DriverProfileCategoriesRoute = getRoute(
  {
    title: t("categories_to_carry"),
    fullPath: "/:locale?/driver/profile/categories",
  },
  "categories",
  lazy(() => import("./profile/categories")),
  null,
);

export const DriverProfileLocationsRoute = getRoute(
  {
    title: t("working_places"),
    fullPath: "/:locale?/driver/profile/locations",
  },
  "locations",
  lazy(() => import("./profile/locations")),
  null,
);

export const DriverProfileDetailsRoute = getRoute(
  { title: t("other_info"), fullPath: "/:locale?/driver/profile/details" },
  "details",
  lazy(() => import("./profile/details")),
  null,
);

export const DriverProfileCompanyRoute = getRoute(
  { title: t("company_info"), fullPath: "/:locale?/driver/profile/company" },
  "company",
  lazy(() => import("pages/client/company")),
  null,
);

export const DriverProfileSettings = getRoute(
  { fullPath: "/:locale?/driver/profile" },
  "driver/profile",
  lazy(() => import("pages/profile/settings")),
  [
    DriverProfileRoute,
    DriverProfileCategoriesRoute,
    DriverProfileLocationsRoute,
    DriverProfileDetailsRoute,
    DriverProfileCompanyRoute,
  ],
);

const DriverRoute = (
  <>
    {DriverProfileSettings}
    {DriverReviewsRoute}
    {DriverCreateReviewRoute}
    {DriverNewOrdersRoute}
    {DriverMyOrdersRoute}
    {DriverArchiveRoute}
    {DriverOrderDetailsRoute}
  </>
);

export default DriverRoute;
